import { connectStepper } from "../util/redux";
import Sentence from "../components/sentence";

export default connectStepper(Sentence);
